import React from 'react';

export default function Icon({ type, theme, url, size, className = '' }) {
    const iconTypeClass = type ? `icon--${type}` : '';
    const iconThemeClass = theme ? `text-${theme}` : '';
    const iconSizeClass = size ? `icon--${size}` : '';

    /* Render */
    return (
        <svg className={`icon ${iconTypeClass} ${iconThemeClass} ${iconSizeClass} ${className}`}>
            <use xlinkHref={url}></use>
        </svg>
    );
}
